import { VersionableId } from '../../../../types/versionableId';
import EsmeApi from '../../../../api/esmeApi';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { selectSelectedSchemaName } from '../../../../store/schemas/schemasSelector';
import { fetchSchemaByName } from '../../../../store/schemas/schemasActions';
import EsmeDeleteDialog from '../../components/esme/EsmeDeleteDialog';
import { AppErrorList, useAppErrorList } from '../../../../shared/components/AppErrorList';

type Props = {
  readonly isOpen: boolean;
  readonly esmeId?: VersionableId;
  readonly hideEsmeDeleteDialog: () => void;
};

const EsmeDeleteDialogContainer = (props: Props) => {
  const {
    isOpen,
    esmeId,
    hideEsmeDeleteDialog,
  } = props;

  const dispatch = useAppDispatch();
  const [{ errors, hasErrors }, { addError, removeError }] = useAppErrorList();
  const selectedSchemaName = useAppSelector(selectSelectedSchemaName);

  const handleDeleteEsme = () => {
    if (selectedSchemaName && esmeId) {
      const esmeName = esmeId.resourceName;

      EsmeApi.deleteEsme(selectedSchemaName, esmeName)
        .then(() => {
          dispatch(fetchSchemaByName(selectedSchemaName));
          hideEsmeDeleteDialog();
        })
        .catch(addError);
    }
  };

  return (
    <>
      { hasErrors && (
        <AppErrorList
          errors={errors}
          onCloseError={removeError}
        />
      )}

      <EsmeDeleteDialog
        isOpen={isOpen}
        esmeId={esmeId}
        onConfirmClick={handleDeleteEsme}
        onCancelClick={hideEsmeDeleteDialog}
      />
    </>
  );
};

export default EsmeDeleteDialogContainer;
